var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-star-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2346 17.1266L4.34792 19.2849L4.08425 19.3386C3.68511 19.4446 3.32124 19.6546 3.0298 19.9471C2.73836 20.2397 2.52979 20.6044 2.4254 21.004C2.321 21.4035 2.32452 21.8236 2.43558 22.2214C2.54665 22.6191 2.76129 22.9803 3.05759 23.2679L13.8423 33.7656L11.2989 48.5939L11.2686 48.8506C11.2442 49.2634 11.3299 49.6753 11.517 50.0441C11.7041 50.4129 11.9858 50.7254 12.3334 50.9495C12.6809 51.1736 13.0818 51.3013 13.4949 51.3195C13.9081 51.3378 14.3186 51.2459 14.6846 51.0533L27.9986 44.0533L41.2822 51.0533L41.5156 51.1606C41.9007 51.3123 42.3193 51.3588 42.7283 51.2954C43.1374 51.2319 43.5222 51.0608 43.8433 50.7996C44.1644 50.5383 44.4102 50.1964 44.5555 49.8088C44.7009 49.4212 44.7404 49.0019 44.6702 48.5939L42.1246 33.7656L52.9139 23.2656L53.0959 23.0673C53.3559 22.7471 53.5264 22.3637 53.5899 21.9561C53.6535 21.5486 53.6079 21.1315 53.4578 20.7473C53.3077 20.3631 53.0584 20.0256 52.7354 19.7691C52.4124 19.5127 52.0271 19.3464 51.6189 19.2873L36.7323 17.1266L30.0776 3.63994C29.885 3.24919 29.5869 2.92014 29.217 2.69005C28.8471 2.45996 28.4202 2.33801 27.9846 2.33801C27.549 2.33801 27.122 2.45996 26.7521 2.69005C26.3822 2.92014 26.0841 3.24919 25.8916 3.63994L19.2346 17.1266Z",
    fill: "#F5A800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconStarFilled);
export default __webpack_public_path__ + "static/media/tabler-icon-star-filled.83583407935654ab7420145351d9151b.svg";
export { ForwardRef as ReactComponent };